export { UPGRADE_URL } from "metabase/common/components/upsells/constants";

export const CAMPAIGN = "data-studio-python-transforms";
export const LOCATION = "data-studio-transforms";
